import Amplify from 'aws-amplify'
import React from 'react'
import ReactGA from 'react-ga'
import { createBrowserHistory } from 'history'
import { withAuthenticator } from 'aws-amplify-react'

import awsconfig from '../aws-exports'
import './App.css'
import { getCurrentAuthenticatedUser } from '../lib/auth'

import GlobalContextProvider from '../contexts/GlobalContext/GlobalContextProvider'
import VocabContextProvider from '../contexts/VocabContextProvider'
import SentenceContextProvider from '../contexts/SentenceContextProvider'
import CoreLayout from './CoreLayout'
import RootRouter from '../routes' // or 'aws-amplify-react-native';

const history = createBrowserHistory()
// google analytics tracking (TODO unit tests for non-test env)
// NODE_ENV is automatically set to 'test', 'development' and 'production' for 'npm
// test/start/build' respectively.
// use `npm run serve` to serve production build
if (process.env.NODE_ENV === 'production') {
  const trackingId = 'UA-157265384-2' // TODO secret
  ReactGA.initialize(trackingId)
  // ReactGA set username async
  getCurrentAuthenticatedUser()
    .then((user) => {
      if (user) ReactGA.set({ userId: user.getUsername() })
    })
    .catch(() => { }) // swallow non-critical error; usually means not authenticated
  history.listen((location) => {
    ReactGA.set({ page: location.hash })
    ReactGA.pageview(location.hash)
  })
}

Amplify.configure(awsconfig)
// rename Username/username to Email/email
Amplify.I18n.setLanguage('en')
Amplify.I18n.putVocabularies({
  en: {
    Username: 'Email',
    'Enter your username': 'Enter your email',
  },
})

const App = () => (
  <GlobalContextProvider>
    <VocabContextProvider>
      <SentenceContextProvider>
        <CoreLayout>
          <RootRouter />
        </CoreLayout>
      </SentenceContextProvider>
    </VocabContextProvider>
  </GlobalContextProvider>
)

const signUpConfig = {
  hiddenDefaults: [
    'username',
    'email',
    'phone_number',
    'password',
  ],
  signUpFields: [
    {
      label: 'Email',
      key: 'username',
      required: true,
      displayOrder: 1,
      type: 'string',
    },
    {
      label: 'Password',
      key: 'password',
      required: true,
      displayOrder: 2,
      type: 'password',
    },
    {
      label: 'Name',
      key: 'name',
      required: false,
      displayOrder: 3,
      type: 'string',
    },
  ],
}

export default withAuthenticator(App, { signUpConfig })
